import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import classNames from 'classnames';
import CookieLink from './CookieLink';

const WP_BASE = `${process.env.REACT_APP_WP_BASE}`;
const IS_HOLIDAY = process.env.REACT_APP_SHOP_ISHOLIDAY === 'true';
const REACT_APP_SILVEROAK_LINK = `${process.env.REACT_APP_SILVEROAK_LINK}`;

const getAbsUrl = href => `${WP_BASE}${href}`;
class HeaderSite extends Component {
  constructor(props) {
    super(props);
    this.state = { activeMenu: null };
  }
  render() {
    const { activeMenu } = this.state;
    const {
      user,
      headerPromos,
      mobileMenu,
      isMobile,
      toggleMobileMenu
    } = this.props;

    const toggleMenu = value =>
      e => {
        e.preventDefault();
        this.setState({ activeMenu: activeMenu === value ? null : value });
      };

    const closeMenu = () => {
      this.setState({ activeMenu: null });
      if (isMobile) {
        toggleMobileMenu();
      }
    };

    const { userId } = user || {};

    const hasUser = !!userId;

    const {
      PROMO0,
      PROMO1,
      PROMO2,
      PROMO3,
      PROMO4,
      PROMO5
    } = headerPromos || {};

    return (
      <header className="site-header" style={{ display: 'block' }}>
        <a href={getAbsUrl('/')} className="site-logo d-none d-md-block">
          TWOMEY
        </a>
        {activeMenu && <div className="backdrop" onClick={toggleMenu(null)} />}
        <div
          className="nav-container"
          style={mobileMenu ? { display: 'block' } : {}}
        >
          <nav className="site-nav">
            <div className="contact-information d-none">
              <a href="tel:1(888) 202-2006" className="telephone">
                (888) 202-2006 M-F, 8-5 PT
              </a>
              <a href="mailto:customercare@twomey.com" className="email">
                customercare@twomey.com
              </a>
            </div>
            <ul className="the-nav">
              <li
                className="promo-trigger promo-loaded"
                id="navigation0"
                data-target-subnav="#subnavshop"
              >
                <a
                  className={classNames(
                    'top-level category-link-shop',
                    activeMenu === 'subnavshop' ? 'nav-active' : ''
                  )}
                  target="_self"
                  href={getAbsUrl('/shop/')}
                  onClick={toggleMenu('subnavshop')}
                >
                  Shop<span><i className="fas fa-chevron-down" /></span>
                </a>
                <div
                  className={classNames(
                    'subnav',
                    activeMenu === 'subnavshop' ? 'ada' : ''
                  )}
                  style={
                    activeMenu === 'subnavshop'
                      ? { display: 'block', opacity: 1 }
                      : { display: 'none', opacity: 0 }
                  }
                >
                  <div className="container subnav-container">

                    <a
                      href="#"
                      onClick={toggleMenu()}
                      className="close-nav-alt"
                      aria-label="Close Navigation"
                    >
                      ×
                    </a>
                    <hr className="subnav-hr" />

                    <div className="row justify-content-md-center subnav-rows">
                      <div className="col-lg-3">
                        <div className="subnav-area">
                          <h2>By Wine</h2>
                          <Link onClick={closeMenu} to="/shop/pinot-noir">
                            Pinot Noir
                          </Link>
                          <Link onClick={closeMenu} to="/shop/sauvignon-blanc">
                            Sauvignon Blanc
                          </Link>
                          <Link onClick={closeMenu} to="/shop/rose">
                            Rosé
                          </Link>
                          <Link onClick={closeMenu} to="/shop">
                            <em>Shop All Wines</em>
                          </Link>
                        </div>
                      </div>
                      <div className="col-lg-3">
                        <div className="subnav-area">
                          <h2>By Category</h2>
                          <Link onClick={closeMenu} to="/shop/ava-wines">
                            AVA Wines
                          </Link>
                          <Link
                            onClick={closeMenu}
                            to="/shop/single-vineyard-wines"
                          >
                            Single Vineyard Wines
                          </Link>
                          <Link onClick={closeMenu} to="/shop/exclusive-offers">
                            Exclusive Offers
                          </Link>

                          {IS_HOLIDAY && <Link onClick={closeMenu} to="/shop/holiday-offers">
                            Holiday Offers
                          </Link>
                          }

                          <CookieLink
                            href={`${REACT_APP_SILVEROAK_LINK}/shop/`}
                            label="Shop Silver Oak"
                          />
                        </div>
                      </div>
                      <div className="col-lg-3">
                        <div className="subnav-area">
                          <h2>Support</h2>
                          <a href={getAbsUrl('/customer-care/')} target="_self">
                            Customer Care
                          </a>
                        </div>
                      </div>
                    </div>

                    <div className="category-link-mobile">
                      <a href="https://twomey.com/shop/" target="_self">
                        Shop Twomey
                      </a>
                    </div>

                  </div>

                  <div className="promo-area">
                    <div className="container">
                      <div className="row justify-content-md-center">
                        <div className="col-md-9">
                          <div
                            className="the-promo"
                            dangerouslySetInnerHTML={{
                              __html: PROMO0 || ''
                            }}
                          />
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </li>

              <li
                className="promo-trigger promo-loaded"
                id="navigation1"
                data-target-subnav="#subnavwines"
              >
                <a
                  href={getAbsUrl('/wines/')}
                  className={classNames(
                    'top-level category-link-wines',
                    activeMenu === 'subnavwines' ? 'nav-active' : ''
                  )}
                  target="_self"
                  onClick={toggleMenu('subnavwines')}
                >
                  Wines<span><i className="fas fa-chevron-down" /></span>
                </a>
                <div
                  className={classNames(
                    'subnav',
                    activeMenu === 'subnavwines' ? 'ada' : ''
                  )}
                  style={
                    activeMenu === 'subnavwines'
                      ? { display: 'block', opacity: 1 }
                      : { display: 'none', opacity: 0 }
                  }
                >
                  <div className="container subnav-container">
                    <a
                      href="#"
                      onClick={toggleMenu()}
                      className="close-nav-alt"
                      aria-label="Close Navigation"
                    >
                      ×
                    </a>
                    <hr className="subnav-hr" />
                    <div className="row justify-content-md-center subnav-rows">
                      <div className="col-lg-3">
                        <div className="subnav-area">
                          <h2>Our Wines</h2>
                          <a
                            href={getAbsUrl('/wines/pinot-noir/')}
                            target="_self"
                          >
                            Pinot Noir
                          </a>
                          <a
                            href={getAbsUrl('/wines/sauvignon-blanc/')}
                            target="_self"
                          >
                            Sauvignon Blanc
                          </a>
                          <a href={getAbsUrl('/wines/rose/')} target="_self">
                            Rosé
                          </a>
                        </div>
                      </div>

                      <div className="col-lg-3">
                        <div className="subnav-area">
                          <h2>Wine Education</h2>
                          <a
                            href={getAbsUrl('/wines/wine-pairing-tips/')}
                            target="_self"
                          >
                            Wine Pairing Tips
                          </a>
                          <a
                            href={getAbsUrl('/wines/aging-red-wines/')}
                            target="_self"
                          >
                            Aging Red Wines
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="category-link-mobile">
                      <a href={getAbsUrl('/wines/')} target="_self">
                        About Our Wines
                      </a>
                    </div>
                  </div>
                  <div className="promo-area">
                    <div className="container">
                      <div className="row justify-content-md-center">
                        <div className="col-md-9">
                          <div
                            className="the-promo"
                            dangerouslySetInnerHTML={{
                              __html: PROMO1 || ''
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>

              <li
                className="promo-trigger promo-loaded"
                id="navigation2"
                data-target-subnav="#subnavvineyards"
              >
                <a
                  href={getAbsUrl('/vineyards/')}
                  className={classNames(
                    'top-level category-link-vineyards',
                    activeMenu === 'subnavvineyards' ? 'nav-active' : ''
                  )}
                  target="_self"
                  onClick={toggleMenu('subnavvineyards')}
                >
                  Vineyards<span><i className="fas fa-chevron-down" /></span>
                </a>
                <div
                  className={classNames(
                    'subnav',
                    activeMenu === 'subnavvineyards' ? 'ada' : ''
                  )}
                  style={
                    activeMenu === 'subnavvineyards'
                      ? { display: 'block', opacity: 1 }
                      : { display: 'none', opacity: 0 }
                  }
                >
                  <div className="container subnav-container">
                    <a
                      href="#"
                      onClick={toggleMenu()}
                      className="close-nav-alt"
                      aria-label="Close Navigation"
                    >
                      ×
                    </a>
                    <hr className="subnav-hr" />
                    <div className="row justify-content-md-center subnav-rows">
                      <div className="col-lg-3">
                        <div className="subnav-area">
                          <h2>California</h2>
                          <a
                            href={getAbsUrl('/vineyards/north-coast/')}
                            target="_self"
                          >
                            North Coast
                          </a>
                        </div>
                      </div>
                      <div className="col-lg-3">
                        <div className="subnav-area">
                          <h2>California</h2>
                          <a
                            href={getAbsUrl('/vineyards/central-coast/')}
                            target="_self"
                          >
                            Central Coast
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="category-link-mobile">
                      <a href={getAbsUrl('/vineyards/')} target="_self">
                        Vineyard Map
                      </a>
                    </div>
                  </div>
                  <div className="promo-area">
                    <div className="container">
                      <div className="row justify-content-md-center">
                        <div className="col-md-9">
                          <div
                            className="the-promo"
                            dangerouslySetInnerHTML={{
                              __html: PROMO2 || ''
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>

              <li
                className="promo-trigger promo-loaded"
                id="navigation3"
                data-target-subnav="#subnavvisit"
              >
                <a
                  href={getAbsUrl('/visit/')}
                  className={classNames(
                    'top-level category-link-visit',
                    activeMenu === 'subnavvisit' ? 'nav-active' : ''
                  )}
                  target="_self"
                  onClick={toggleMenu('subnavvisit')}
                >
                  Visit<span><i className="fas fa-chevron-down" /></span>
                </a>
                <div
                  className={classNames(
                    'subnav',
                    activeMenu === 'subnavvisit' ? 'ada' : ''
                  )}
                  style={
                    activeMenu === 'subnavvisit'
                      ? { display: 'block', opacity: 1 }
                      : { display: 'none', opacity: 0 }
                  }
                >
                  <div className="container subnav-container">
                    <a
                      href="#"
                      onClick={toggleMenu()}
                      className="close-nav-alt"
                      aria-label="Close Navigation"
                    >
                      ×
                    </a>
                    <hr className="subnav-hr" />
                    <div className="row justify-content-md-center subnav-rows">
                      <div className="col-lg-3">
                        <div className="subnav-area">
                          <h2>SONOMA</h2>
                          <a
                            href={getAbsUrl(
                              '/visit/healdsburg-russian-river-valley/'
                            )}
                            target="_self"
                          >
                            Healdsburg, Russian River Valley
                          </a>
                        </div>
                      </div>
                      <div className="col-lg-3">
                        <div className="subnav-area">
                          <h2>EVENTS</h2>
                          <a href={getAbsUrl('/wine-events/')} target="_self">
                            Upcoming Wine Events
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="category-link-mobile">
                      <a href={getAbsUrl('/visit/')} target="_self">
                        Plan Your Visit
                      </a>
                    </div>
                  </div>
                  <div className="promo-area">
                    <div className="container">
                      <div className="row justify-content-md-center">
                        <div className="col-md-9">
                          <div
                            className="the-promo"
                            dangerouslySetInnerHTML={{
                              __html: PROMO3 || ''
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>

              <li
                className="promo-trigger promo-loaded"
                id="navigation4"
                data-target-subnav="#subnavclub"
              >
                <a
                  href={getAbsUrl('/membership/')}
                  className={classNames(
                    'top-level category-link-join',
                    activeMenu === 'subnavclub' ? 'nav-active' : ''
                  )}
                  target="_self"
                  onClick={toggleMenu('subnavclub')}
                >
                  Join<span><i className="fas fa-chevron-down" /></span>
                </a>
                <div
                  className={classNames(
                    'subnav',
                    activeMenu === 'subnavclub' ? 'ada' : ''
                  )}
                  style={
                    activeMenu === 'subnavclub'
                      ? { display: 'block', opacity: 1 }
                      : { display: 'none', opacity: 0 }
                  }
                >
                  <div className="container subnav-container">
                    <a
                      href="#"
                      onClick={toggleMenu()}
                      className="close-nav-alt"
                      aria-label="Close Navigation"
                    >
                      ×
                    </a>
                    <hr className="subnav-hr" />
                    <div className="row justify-content-md-center subnav-rows">
                      <div className="col-lg-3">
                        <div className="subnav-area">
                          <h2>Membership</h2>
                          <a href={getAbsUrl('/membership/')} target="_self">
                            Become a Member
                          </a>
                          <Link to={'/shop/account/login/'}>
                            Account Login
                          </Link>
                        </div>
                      </div>
                      <div className="col-lg-3">
                        <div className="subnav-area">
                          <h2>Events</h2>
                          <a
                            href={getAbsUrl('/wine-events/#ClubEvents')}
                            target="_self"
                          >
                            Member Events
                          </a>
                          <a
                            href={getAbsUrl('/contact/#ClubTwomey')}
                            target="_self"
                          >
                            Contact
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="category-link-mobile">
                      <a href={getAbsUrl('/membership/')} target="_self">
                        About Membership
                      </a>
                    </div>
                  </div>
                  <div className="promo-area">
                    <div className="container">
                      <div className="row justify-content-md-center">
                        <div className="col-md-9">
                          <div
                            className="the-promo"
                            dangerouslySetInnerHTML={{
                              __html: PROMO4 || ''
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>

              <li
                className="promo-trigger promo-loaded"
                id="navigation5"
                data-target-subnav="#subnavabout"
              >
                <a
                  href={getAbsUrl('/about/')}
                  className={classNames(
                    'top-level category-link-about',
                    activeMenu === 'subnavabout' ? 'nav-active' : ''
                  )}
                  target="_self"
                  onClick={toggleMenu('subnavabout')}
                >
                  About<span><i className="fas fa-chevron-down" /></span>
                </a>
                <div
                  className={classNames(
                    'subnav',
                    activeMenu === 'subnavabout' ? 'ada' : ''
                  )}
                  style={
                    activeMenu === 'subnavabout'
                      ? { display: 'block', opacity: 1 }
                      : { display: 'none', opacity: 0 }
                  }
                >
                  <div className="container subnav-container">
                    <a
                      href="#"
                      onClick={toggleMenu()}
                      className="close-nav-alt"
                      aria-label="Close Navigation"
                    >
                      ×
                    </a>
                    <hr className="subnav-hr" />
                    <div className="row justify-content-md-center subnav-rows">
                      <div className="col-lg-3">
                        <div className="subnav-area">
                          <h2>About Twomey</h2>
                          <a
                            href={getAbsUrl('/about/our-story/')}
                            target="_self"
                          >
                            Story
                          </a>
                          <a href={getAbsUrl('/about/team/')} target="_self">
                            Team
                          </a>
                          <a href={getAbsUrl('/about/jobs/')} target="_self">
                            Jobs
                          </a>
                          <a href={getAbsUrl('/contact/')} target="_self">
                            Contact
                          </a>
                        </div>
                      </div>
                      <div className="col-lg-3">
                        <div className="subnav-area">
                          <h2>Silver Oak</h2>
                          <a
                            href={getAbsUrl('/about/family-of-silver-oak/')}
                            target="_self"
                          >
                            Family of Silver Oak
                          </a>
                          <a href="https://www.silveroak.com/" target="_blank">
                            SilverOak.com
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="category-link-mobile">
                      <a href={getAbsUrl('/about/')} target="_self">
                        The Twomey Story
                      </a>
                    </div>
                  </div>
                  <div className="promo-area">
                    <div className="container">
                      <div className="row justify-content-md-center">
                        <div className="col-md-9">
                          <div
                            className="the-promo"
                            dangerouslySetInnerHTML={{
                              __html: PROMO5 || ''
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>

            </ul>
          </nav>

          <nav className="site-nav-secondary">
            <ul>
              <li className="sub-support">
                <a href={getAbsUrl(user ? '/account/' : '/account/login/')}>Account</a>
              </li>
              <li className="sub-support">
                <a href={getAbsUrl('/customer-care/')}>Customer Support</a>
              </li>
              <li><a href={getAbsUrl('/contact/')}>Contact</a></li>
              <li><a href={getAbsUrl('/subscribe/')}>Subscribe</a></li>
            </ul>
            <div className="mobile-nav-branding d-lg-none">
              <CookieLink
                href={`${REACT_APP_SILVEROAK_LINK}/shop/`}
                target="_blank"
                className="silveroak-brand"
                label="Silver Oak"
              />
              <a
                href="https://timeless.wine/"
                target="_blank"
                className="timeless-brand"
              >
                Timeless
              </a>
            </div>

          </nav>
        </div>
      </header>
    );
  }
}

const mapState = state => {
  const {
    result: user
  } = state.postLogin.toJS();

  const { headerPromos } = state.wordpress || {};

  return {
    user,
    headerPromos
  };
};

export default connect(mapState)(HeaderSite);
